module.exports = __webpack_public_path__ + "static/media/popularSpaceBadge.a49c1987.svg";